var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-tabs-container"},[_c('el-tabs',{model:{value:(_vm.tab_index),callback:function ($$v) {_vm.tab_index=$$v},expression:"tab_index"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('tab.cost_cacl')}},[_c('CostCaclEdit')],1),_c('el-tab-pane',{attrs:{"label":_vm.$t('tab.cost_compare')}},[_c('CostCaclSearch')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }